import React, { useEffect, useState } from "react";
import "./OrderSummaryComponent.css";
import { Form } from "react-bootstrap";
import Black_Btn from "../../Common-Component/Common_Btn/Black_Btn/Black_Btn";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../../features/cart/cartSlice";

const OrderSummaryComponent = ({cart, setShwoPlaceOrder }) => {
  const [isDataSaved, setIsDataSaved] = useState(false);
 

  return (
    <section className="OrderSummaryComponent SelectAddressComponent">
      <p className="heading_text">Order Summary</p>

      {!isDataSaved && (
        <>
          <div className="order_info_cards_holder">
            <div className="order_info_cards">
              {cart?.data?.data?.map((val, index) => (
                <div className="row">
                  <div className="col-lg-2 col-md-2 col-sm-3 col-12">
                    <div className="product_img_card">
                      <img
                        src={
                          process.env.REACT_APP_IMG_URL +
                          val?.Product?.Product_Images[0]?.image
                        }
                        className="product_img"
                      />
                    </div>
                  </div>

                  <div className="col-lg-10 col-md-10 col-sm-9 col-12">
                    <div className="product_info_main_card">
                      <div className="product_info_div">
                        <p className="product_name">{val?.Product?.name}</p>
                        <p className="qty_text">
                          Quantity: {val?.Product_Combination?.Qty?.name}
                        </p>
                        <p className="price">
                          ₹{(Number(val?.Product_Combination?.total) || 0).toFixed(2)}
                        </p>
                      </div>

                      <div className="other_info_div">
                        <div className="radio_div">
                          <Form.Check
                            type="radio"
                            name="radioGroup"
                            value="option1"
                            checked={true}
                          />
                        </div>
                        <div className="heading_part">
                          <p className="heading">Standard Delivery</p>
                          <p className="subtext">Delivery Charges: ₹75.00</p>
                          <p className="subtext">Wed, Feb 5</p>
                        </div>
                      </div>

                      <div className="upper_half_circle"></div>
                      <div className="lower_half_circle"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className="btn_holder"
            onClick={() => {
              setIsDataSaved(true);
              setShwoPlaceOrder(true);
             
            }}
            // onClick={(() => setIsDataSaved(true))}
          >
            <Black_Btn btnText="Save & Continue" />
          </div>
        </>
      )}

      {isDataSaved && (
        <div className="show_items_div">
          <div className="items_div">
            <p className="item_text">{cart?.data?.data.length} items</p>
          </div>

          {/* <div className='change_text_div'>
            <p className='text'>Change</p>
          </div> */}
        </div>
      )}

      {/* {!isDataSaved && (
        <div className='btn_holder' onClick={() => setIsDataSaved(true)}>
          <Black_Btn btnText="Save & Continue" />
        </div>
      )} */}
    </section>
  );
};

export default OrderSummaryComponent;
